






































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import uuid from 'uuid/v4';
import merge from 'lodash/merge';

import { Organization } from '@/common/Organizations';

import Alert from '@/components/Global/Alert.vue';
import TextField from '@/components/Form/TextField.vue';
import SwitchField from '@/components/Form/SwitchField.vue';

import StaffOrganizationInviteAdminModal from '@/components/Modal/StaffOrganizationsInviteAdmin.vue';
import StaffOrganizationAddAdminModal from '@/components/Modal/StaffOrganizationsAddAdmin.vue';

import { required, requiredIf } from 'vuelidate/lib/validators';

@Component({
	name: 'UsersTab',
	components: {
		Alert,
		TextField,
		SwitchField,
		'modal-invite-admin': StaffOrganizationInviteAdminModal,
		'modal-add-admin': StaffOrganizationAddAdminModal,
	},
})
export default class OrgManagement extends Vue {
	@State('organization', { namespace: 'Organizations' }) private organization: Organization;
	@Action('updateOrgAdmin', { namespace: 'Organizations' }) private updateOrgAdmin!: any;
	private paginate: any = ['users'];
	private page: number = 0;
	private error: boolean = false;
	private success: boolean = false;
	private inviteUserUUID: string = uuid();
	private addAdminUUID: string = uuid();
	private uuid: typeof uuid = uuid;
	private selectedUser: any = {};

	private fields: Organization = {
		org_id: '',
		org_name: '',
		is_agency: false,
		brokerageId: '',
		address: {
			address_line_1: '',
			address_line_2: '',
			city: '',
			state: '',
			zipcode: '',
		},
		phone_number: '',
		users: [],
		org_admins: [],
	};

	get users() {
		const users = this.fields.users.filter(
			user => this.fields.org_admins[user.sub] === undefined,
		);

		return users;
	}

	get adminUsers() {
		return this.fields.users.filter(user => this.fields.org_admins[user.sub] !== undefined);
	}

	@Watch('organization')
	private watchOrganization(newValue, oldValue) {
		this.fields = this.organization;
	}

	@Watch('users')
	private watchUsers() {
		if (this.users.length <= 1) {
			this.paginate.users.page = 0;
		}
	}

	private openUser(id) {
		this.$router.push({
			name: 'staffusermanagementsingle',
			params: {
				user_id: id,
			},
		});
	}

	private openInviteModal() {
		this.inviteUserUUID = uuid();
	}

	private async openAddAdminModal(e, user, type = 'add') {
		e.preventDefault();
		this.addAdminUUID = uuid();
		user.type = type;
		if (type === 'edit') {
			user.admin = this.fields.org_admins[user.sub];
		}
		this.selectedUser = user;
	}

	private async updateAdmin(sub, status) {
		this.error = false;
		this.success = false;

		const params = {
			orgId: this.fields.org_id,
			sub,
			status,
		};

		try {
			await this.updateOrgAdmin(params);
			this.success = true;
		} catch (e) {
			this.error = true;
		}
	}

	private created() {
		this.fields = this.organization;
	}
}
